'use client';
import { Button } from '@mantine/core';
export default function BioError({ reset }: { reset: () => void }) {
  return (
    <main className="mx-auto max-w-lg px-6 py-24 text-primary">
      <h1 className="text-3xl font-semibold">This page could not be loaded</h1>
      <p className="my-4 text-secondary">Please try again in a moment.</p>
      <Button onClick={reset}>Try again</Button>
    </main>
  );
}
